import {IntermediatePart} from "../../intermediatePart";
import {METADATA, PLACEMENTS} from "../../constants";

export default class Faucet extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'faucet';
    this.partName = 'Faucet';
    this.translateId = "visualizer.kitchen.countertop.faucet";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    if (dbFeature.metaData && dbFeature.metaData["Placement"] && dbFeature.metaData["Placement"].includes(PLACEMENTS.Island)) {
      return false
    }
    const mountTypeMeta = dbFeature.metaData["MountType"];
    if (mountTypeMeta && mountTypeMeta.includes("U")) {
      METADATA.sinkUTypes.forEach(metaValue => {
        if (!mountTypeMeta.includes(metaValue)){
          mountTypeMeta.push(metaValue)
        }
      })
    }
    return super.load_(dbFeature, new Faucet());
  }

  getCurrentSinkMetaData() {
    const sinkParent = this.getParent().sink;
    let metaObject = {};
    if (sinkParent && sinkParent.activeFeature) {
      const sinkMeta = sinkParent.activeFeature.metaData["MountType"];
      if (sinkMeta && (sinkMeta !== "0") && !sinkMeta.includes("0")) {
        metaObject["MountType"] = Array.isArray(sinkMeta) ? sinkMeta[0] : sinkMeta
      }
      const mountHolesMeta = sinkParent.activeFeature.metaData["MountHoles"];
      if (mountHolesMeta && (mountHolesMeta !== "0") && !mountHolesMeta.includes("0")) { // if 0 - we are showing all faucets
        metaObject["MountHoles"] = mountHolesMeta
      }
    }
    return metaObject
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const currentSinkMetaData = this.getCurrentSinkMetaData();
    ["MountType", "MountHoles"].forEach(propName => {
      if (currentSinkMetaData[propName]) {
        conditions.push({
          propName,
          propValue: currentSinkMetaData[propName]
        })
      }
    })
    // console.log("conditions", conditions);
    return conditions;
  }

  disabledClick() {
    const relatedFaucet = this.getParent().sink;
    if (relatedFaucet) {
      relatedFaucet.disabled = this.disabled;
    }
  }
}
